<template>
  <v-row>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="pr-4">
      <v-col>
        <v-toolbar flat class="sub-toolbar" height="50px">
          <v-toolbar-title class="primary--text">Cities</v-toolbar-title>
          <div class="pl-4">
            <v-btn small outlined color="primary" @click="onNewItem">
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
      </v-col>

      <v-col cols="3" class="d-flex justify-content-center pt-3">
        <input class="form-control" v-model="searchTable" placeholder="Search city" />
      </v-col>

      <v-col class="d-flex justify-content-end pt-3">
        <v-btn
          small
          tile
          depressed
          color="primary"
          class="font-weight-bold text-button"
          @click="loadCities"
          >LOAD</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row no-gutters>
      <v-col class="px-2">
        <v-card color="white" flat tile>
          <v-data-table
            dense
            :search="searchTable"
            :items="cities"
            :headers="headers"
            no-data-text="Click load to display cities"
            item-key="code"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.code">
                <td class="caption text-left pl-2">{{ item.code }}</td>
                <td class="caption text-left px-2">{{ item.name }}</td>
                <td class="caption text-left px-2">
                  <v-chip
                    v-for="(alias, i) in item.alias"
                    :key="i"
                    x-small
                    class="px-2 mx-1 mt-1"
                    >{{ alias }}</v-chip
                  >
                </td>
                <td class="caption text-left">
                  {{ item.administrative_area_level_1[0] }}
                </td>
                <!-- <td class="caption text-left">
                  <template v-if="item.locality != null">
                    <v-chip
                      v-for="(locality, i) in item.locality"
                      :key="i"
                      x-small
                      class="px-2 mx-1 mt-1"
                      >{{ locality }}</v-chip
                    >
                  </template>

                  <template v-else>
                    {{ item.locality }}
                  </template>
                </td> -->
                <td class="caption text-left">{{ item.country }}</td>
                <td class="caption text-left pl-2">
                  <v-row align="center">
                    <v-chip x-small class="pa-1 overline"
                      >{{ item.geocode.geometry.location.lat.toFixed(2) }},
                      {{ item.geocode.geometry.location.lng.toFixed(2) }}</v-chip
                    >
                  </v-row>
                </td>
                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small @click="onToggleTrash(item)">
                        <v-icon size="20" :color="item.trash ? 'error' : 'grey'"
                          >mdi-delete</v-icon
                        >
                      </v-btn>
                    </template>
                    {{ item.trash ? "Untrash city" : "Tash city" }}
                  </v-tooltip>
                </td>
                <td class="caption text-center">
                  {{ item.updated.split(" ")[0] }}
                </td>
                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small @click="onUpdateCity(item)">
                        <v-icon size="20" color="primary">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    Edit city
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogUpdateItem"
      persistent
      :scrollable="isUpdate"
      max-width="1200px"
    >
      <v-card color="white" flat tile>
        <v-card-title class="dialog-header-title">{{ titleDialog }}</v-card-title>

        <v-divider></v-divider>
        <!-- <v-alert v-model="alert" :type="alertType" dismissible>{{
              alertMessage
            }}</v-alert> -->
        <v-card-text
          v-if="city != null"
          class="py-1 px-2"
          :style="isUpdate ? 'height: 490px;' : ''"
        >
          <v-row no-gutters>
            <v-col>
              <v-row dense>
                <v-col cols="2">
                  <span>City Code</span>
                  <input class="form-control" :disabled="isUpdate" v-model="city.code" />
                </v-col>

                <v-col>
                  <span>Display Name</span>
                  <input class="form-control" v-model="city.name" />
                </v-col>

                <v-col>
                  <span>City Name</span>
                  <input class="form-control" v-model="city.search_name" />
                </v-col>

                <v-col cols="3">
                  <span>Country:</span>
                  <v-autocomplete
                    :items="countries"
                    class="form-control"
                    v-model="city.code_country"
                    item-value="code"
                    item-text="name"
                    flat
                    solo
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row dense v-if="isUpdate">
                <v-col>
                  <v-row dense>
                    <v-col cols="6">
                      <span>
                        Location Alias:
                        <span class="overline text-lowercase primary--text"
                          >tap enter after a word or phrase to add</span
                        >
                      </span>
                      <input-tag
                        placeholder="add alias"
                        :before-adding="(alias) => alias.toLowerCase().trim()"
                        v-model="location_alias"
                      ></input-tag>
                    </v-col>

                    <v-col>
                      <span>State</span>
                      <input-tag
                        placeholder="add state"
                        :before-adding="(state) => state.toLowerCase().trim()"
                        v-model="city.administrative_area_level_1"
                      ></input-tag>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      <span>Locality / City</span>
                      <input-tag
                        placeholder="add city"
                        :before-adding="(locality) => locality.toLowerCase().trim()"
                        v-model="city.locality"
                      ></input-tag>
                    </v-col>

                    <v-col>
                      <span>Sub-Locality / Township</span>
                      <input-tag
                        placeholder="add township"
                        :before-adding="(sublocality) => sublocality.toLowerCase().trim()"
                        v-model="city.sublocality"
                      ></input-tag>
                    </v-col>

                    <v-col cols="2">
                      <span>Route</span>
                      <input-tag
                        placeholder="add route"
                        :before-adding="(route) => route.toLowerCase().trim()"
                        v-model="city.route"
                      ></input-tag>
                    </v-col>

                    <v-col cols="2">
                      <span>Neighborhood</span>
                      <input-tag
                        placeholder="add neighborhood"
                        :before-adding="
                          (neighborhood) => neighborhood.toLowerCase().trim()
                        "
                        v-model="city.neighborhood"
                      ></input-tag>
                    </v-col>

                    <v-col cols="1">
                      <span>Postal Code</span>
                      <input class="form-control rounded-0" v-model="city.postal_code" />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider class="my-1"></v-divider>
                  </v-row>

                  <v-row dense class="mb-2" justify="start">
                    <span class="font-weight-bold caption">Search Address:</span>
                    <input class="form-control" id="autocomplete" />
                  </v-row>

                  <v-row justify="start" class="pb-2">
                    <span class="text-sm-caption font-italic">{{
                      city.geocode.formatted_address
                    }}</span>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>
                      <v-card tile elevation="4" flat height="250" color="white">
                        <div id="map" style="width: 100%; height: 100%"></div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mb-1 mt-0"></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              v-show="isUpdate"
              @click="resetCity"
              class="font-weight-bold text-button mx-2"
              color="secondary"
              text
              small
              >RESET</v-btn
            >

            <v-btn
              v-show="isCreate"
              @click="createCity"
              class="font-weight-bold text-button mr-2"
              color="primary"
              tile
              depressed
              small
              >CREATE</v-btn
            >

            <v-btn
              v-show="isUpdate"
              @click="updateCity"
              class="font-weight-bold text-button mr-3"
              color="primary"
              tile
              depressed
              small
              >SAVE</v-btn
            >

            <v-btn
              @click="onCloseDialog"
              class="font-weight-bold text-button ml-2"
              color="error"
              tile
              depressed
              small
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import constant from "@/const";
import InputTag from "vue-input-tag";
export default {
  components: { InputTag },
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      CONSTANT: constant,

      searchTable: null,

      headers: [
        {
          text: "Code",
          value: "code",
          align: "left",
          sortable: true,
        },
        {
          text: "Display Name",
          value: "name",
          align: "left",
          sortable: true,
          width: 200,
        },
        {
          text: "Alias",
          value: "alias",
          align: "left",
          sortable: true,
          width: 200,
        },
        {
          text: "State",
          value: "administrative_area_level_1",
          align: "left",
          sortable: true,
        },
        // {
        //   text: "City",
        //   value: "locality",
        //   align: "left",
        //   sortable: true
        // },
        {
          text: "Country",
          value: "country",
          align: "left",
          sortable: true,
        },
        {
          text: "Geocode",
          value: "geocode",
          align: "left",
          sortable: false,
        },
        {
          text: "Trashed",
          value: "trash",
          align: "center",
          sortable: true,
        },
        {
          text: "Updated",
          value: "updated",
          align: "center",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
        },
      ],

      countries: [],
      cities: [],
      city: null,
      city_sync: {},
      location_alias: [],

      isCreate: false,
      isUpdate: false,
      dialogUpdateItem: false,
      titleDialog: "Add new city",

      autocomplete: null,
      rectangle: null,
      componentForm: [
        "postal_code",
        "route",
        "neighborhood",
        "sublocality",
        "locality",
        "administrative_area_level_1",
      ],
    };
  },

  async created() {
    this.$root.blockUImsg = "please wait...";
    this.$root.blockUIshow = true;
    // verify user token
    await this.$root.verify_user_token();

    this.$root.blockUIshow = false;
  },

  mounted() {},

  watch: {},

  methods: {
    /**
     * load cities
     */
    async loadCities() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/cities`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.cities = resp.data.data;
      } else {
        this.cities = [];
      }

      this.$root.blockUIshow = false;
    },

    /**
     * load countries
     */
    async loadCountries() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/countries`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.countries = resp.data.data;
      } else {
        this.countries = [];
      }

      this.$root.blockUIshow = false;
    },

    /**
     * on create new city
     */
    async onNewItem() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/geography/init/city`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.city = resp.data.data;

        // fetch countries
        this.loadCountries();
        this.isCreate = true;
        this.isUpdate = false;
        this.titleDialog = "Add new city";
        this.dialogUpdateItem = true;
      } else {
        this.city = null;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Initialise the google Map
     */
    initMap() {
      // instantiate the google map api
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 13,
        center: {
          lat: this.city.geocode.geometry.location.lat,
          lng: this.city.geocode.geometry.location.lng,
        },
        mapTypeId: "roadmap",
      });

      // draw the rectangle for the viewport
      this.rectangle = new google.maps.Rectangle({
        strokeColor: "#FF5252",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF5252",
        fillOpacity: 0.35,
        map,
        bounds: {
          north: this.city.geocode.geometry.viewport.northeast.lat,
          south: this.city.geocode.geometry.viewport.southwest.lat,
          east: this.city.geocode.geometry.viewport.northeast.lng,
          west: this.city.geocode.geometry.viewport.southwest.lng,
        },
        editable: true,
      });

      // this.rectangle.setMap(map)
      // Add an event listener on the rectangle.
      this.rectangle.addListener("bounds_changed", this.showNewRect);

      // Configure the click listener.
      map.addListener("click", this.onClickMap);
    },

    /** on map click */
    onClickMap(mapClickEvent) {
      const geocoder = new google.maps.Geocoder();
      this.geocodeLatLng(geocoder, mapClickEvent.latLng);
    },

    /** on reverse geocode */
    geocodeLatLng(geocoder, latLng) {
      const latlng = {
        lat: latLng.lat(),
        lng: latLng.lng(),
      };
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            // console.log("result: ", results[0])
            // fill in the city address components
            this.fillInAddress(results[0]);
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      });
    },

    /** Show the new coordinates for the rectangle in an info window. */
    showNewRect() {
      const ne = this.rectangle.getBounds().getNorthEast();
      const sw = this.rectangle.getBounds().getSouthWest();

      // update the geocode geometry
      this.city.geocode.geometry.viewport.northeast.lat = ne.lat();
      this.city.geocode.geometry.viewport.southwest.lat = sw.lat();
      this.city.geocode.geometry.viewport.northeast.lng = ne.lng();
      this.city.geocode.geometry.viewport.southwest.lng = sw.lng();
    },

    /**
     * On Autocomplete
     */
    initAutocomplete() {
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      // this.autocomplete = new google.maps.places.Autocomplete(
      //   document.getElementById("autocomplete"),
      //   { types: ["geocode"] }
      // )
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
          componentRestrictions: {
            country: this.city.code_country.toLowerCase(),
          },
        }
      );
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.autocomplete.setFields([
        "address_components",
        "formatted_address",
        "name",
        "geometry",
        "place_id",
        "types",
        "plus_code",
      ]);
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.autocomplete.addListener("place_changed", () => {
        // Get the place details from the autocomplete object.
        const place = this.autocomplete.getPlace();

        // fill in the address components
        this.fillInAddress(place);
      });
    },

    /** insert and fill in the address components */
    fillInAddress(place) {
      // update the city geocode data
      this.city.geocode.address_components = place.address_components;
      this.city.geocode.formatted_address = place.formatted_address;
      this.city.geocode.place_id = place.place_id;
      this.city.geocode.plus_code = place.plus_code;
      this.city.geocode.types = place.types;
      if (place.name) {
        this.city.geocode.name = place.name;
        this.city.search_name = place.name.toLowerCase();
      }

      this.city.geocode.geometry.location.lat = place.geometry.location.lat();
      this.city.geocode.geometry.location.lng = place.geometry.location.lng();

      this.city.geocode.geometry.viewport.northeast.lat = place.geometry.viewport.toJSON().north;
      this.city.geocode.geometry.viewport.southwest.lat = place.geometry.viewport.toJSON().south;
      this.city.geocode.geometry.viewport.northeast.lng = place.geometry.viewport.toJSON().east;
      this.city.geocode.geometry.viewport.southwest.lng = place.geometry.viewport.toJSON().west;

      let filled = [];
      this.location_alias = [];
      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      for (const component of place.address_components) {
        // assign the designated address component field
        for (let i = 0; i < this.componentForm.length; i++) {
          const item = this.componentForm[i];
          // if filled then skip
          if (filled.includes(item)) {
            continue;
          }
          if (component.types.includes(item)) {
            if (item == "postal_code") {
              this.city.postal_code = component.long_name;
              break;
            } else {
              this.city[item] = [];
              this.city[item].push(component.long_name);

              // add sublocality & route & neighborhood to alias
              if (["neighborhood", "route", "sublocality"].includes(item)) {
                if (!this.location_alias.includes(component.long_name)) {
                  this.location_alias.push(component.long_name);
                }
              }
              // filled
              filled.push(item);
              break;
            }
          } else {
            if (item == "postal_code") {
              this.city[item] = null;
            } else {
              this.city[item] = [];
            }
          }
        }
      }

      // visualise the data in the map
      this.initMap();
    },

    /**
     * on update city
     */
    async onUpdateCity(city) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/city/${city.code}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // clone
        this.city_sync = city;
        this.city = resp.data.data;
        // insert alias
        this.location_alias = this.city.alias;

        // fetch countries
        this.loadCountries();
        this.titleDialog = "Edit city";
        this.isCreate = false;
        this.isUpdate = true;
        this.dialogUpdateItem = true;

        setTimeout(() => {
          // visualise the data in the map, by instantiating the map
          this.initMap();

          // instantiate the autocomplete widget input element
          this.initAutocomplete();
        }, 500);
      } else {
        this.city = null;
      }

      this.$root.blockUIshow = false;
    },

    /** reset the selected city object */
    resetCity() {
      this.city = JSON.parse(JSON.stringify(this.city_sync));
    },

    /**
     * create city
     */
    async createCity() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      // insert the alias
      this.city.alias = this.location_alias;

      let resp = await this.$https.post(`/api/city/${this.city.code}`, this.city);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.city = resp.data.data;
        this.cities.push(this.city);

        this.titleDialog = "Edit city";
        this.isCreate = false;
        this.isUpdate = true;

        setTimeout(() => {
          // visualise the data in the map, by instantiating the map
          this.initMap();

          // instantiate the autocomplete widget input element
          this.initAutocomplete();
        }, 500);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * update city
     */
    async updateCity() {
      if (this.city.code == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "City code is not provided";
        return;
      }

      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      // insert the alias
      this.city.alias = this.location_alias;

      let resp = await this.$https.put(`/api/city/${this.city.code}`, this.city);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated data
        this.city_sync = Object.assign(this.city_sync, resp.data.data);

        this.city = resp.data.data;
        // insert alias
        this.location_alias = this.city.alias;

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * On trash or untrash city
     */
    async onToggleTrash(city) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = null;

      if (city.trash) {
        resp = await this.$https.post(`/api/city/${city.code}/restore`);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          city.trash = false;
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        resp = await this.$https.delete(`/api/city/${city.code}`);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          city.trash = true;
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      }

      this.$root.blockUIshow = false;
    },

    /**
     * close dialog and refresh
     */
    onCloseDialog() {
      this.city = null;
      //close the dialog
      this.dialogUpdateItem = false;
      this.isCreate = false;
      this.isUpdate = false;
    },
  },

  computed: {},
};
</script>

<style scoped>
.v-data-table {
  border: 2px solid #e0e0e0;
}
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}
</style>
